// extracted by mini-css-extract-plugin
module.exports = {"tileContainer":"Hero_tileContainer__nWsP_","nameplateImage":"Hero_nameplateImage___7TVL","seriesOverlay":"Hero_seriesOverlay__V9BgB"};